import React, { useEffect, useState } from "react";
import commonStyle from "../common.module.css";
import TopBar from "../../Components/TopBar/TopBar";
import Loading from "../../Components/Loading/Loading";
import { BOOKINGFORM_COLUMNS } from "../../Values/tables";
import { connect, useDispatch } from "react-redux";
import { filterStatus, searchOrganizationItem } from "../../Values/utils";
import styles from "./Booking.module.css";
import CustomTable from "../../Components/CustomTable/CustomTable";
import axios from "axios";
import { url } from "../../Values/constants";
import { themeColors } from "../../Components/theme";
import { useMediaQuery } from "@material-ui/core";
import AddBookingModel from "../../Components/Modals/AddBooking/AddBookingModel";

const Booking = ({ history, theme }: any) => {
  const dispatcher = useDispatch();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [organizationData, setOrganizationData] = useState<any[] | undefined>(undefined);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [addModal, setAddModal] = useState(false);
  const [searchQuery, setsearchQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [columnModal, setColumnModal] = useState(false);
  const [load, setLoad] = useState(false);
  const [selectedIndustries, setSelectedIndustries] = useState("");
  const [allIndustries, setallIndustries] = useState<{ industry_id: string; status: string; industry_name: string; screens: string[] }[]>([]);

  useEffect(() => {
    getAllIndustries();
  }, []);

  const getAllIndustries = async () => {
    setLoad(true);
    const apiData = {
      status: "Launched",
    };
    try {
      const res = await axios.post(url + "/headers/getAllIndustries", apiData);
      setallIndustries(res.data);
      setLoad(false);
    } catch (e) {
      console.log("Provide Exception By get all industries :", e);
      setLoad(false);
    }
  };

  const handleIndustriesChange = (e: any) => {
    setSelectedIndustries(e.target.value);
  };

  useEffect(() => {
    getDefaultBookingHeaders();
  }, []);

  useEffect(() => {
    if (organizationData !== undefined) {
      setFilterData(organizationData);
    }
  }, [organizationData, dispatcher]);

  useEffect(() => {
    if (status === "ALL") {
      if (organizationData) {
        const data = searchOrganizationItem(organizationData, searchQuery);
        setTemporaryData(data);
        setFilterData(data);
      }
    } else {
      const data = searchOrganizationItem(temporaryData, searchQuery);
      setFilterData(data);
    }
  }, [searchQuery, organizationData]);

  useEffect(() => {
    if (searchQuery === "") {
      if (organizationData) {
        const data = filterStatus(organizationData, status);
        setTemporaryData(data);
        setFilterData(data);
      }
    } else {
      const data = filterStatus(temporaryData, status);
      setFilterData(data);
    }
  }, [status, organizationData]);

  const getDefaultBookingHeaders = async () => {
    setLoad(true);
    try {
      const res = await axios.get(url + "/bookings/getBookingFrom");
      let resSortData = res.data.sort(
        (a: any, b: any) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setOrganizationData(resSortData);
      setLoad(false);
    } catch (e) {
      setLoad(false);
    }
  };

  const onSave = () => {
    localStorage.setItem("selectedIndustries", selectedIndustries);
    localStorage.setItem("allIndustries", JSON.stringify(allIndustries));
    history.push("/addBookingForm");
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...containerStyles }}>
        {load === true && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <TopBar
            history={history}
            title={"Add Form"}
            path={"addForm"}
            onChange={(val) => setsearchQuery(val)}
            setStatus={(status) => setStatus(status)}
            filterText="Status"
            status={status}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={true}
            setApiModal={(data) => setAddModal(data)}
          />
        </div>
        <div className={isMobile ? commonStyle.parent : commonStyle.parentp} style={{ minHeight: "450px", ...containerStyles }}>
          <CustomTable
            tableColumns={BOOKINGFORM_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Booking From Header"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            setSearchedItem={(val) => setsearchQuery(val)}
          />
        </div>
      </div>
      {addModal === true && (
        <AddBookingModel
          open={addModal}
          close={() => setAddModal(false)}
          allIndustries={allIndustries}
          selectedIndustries={selectedIndustries}
          handleIndustriesChange={handleIndustriesChange}
          onSave={onSave}
          load={load}
        />
      )}
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
  };
};
export default connect(mapStateToProps)(Booking);
